// extracted by mini-css-extract-plugin
export default {"link":"ChapterPage_link__lAfmQ","markdown":"ChapterPage_markdown__3pu+L"};